export default {
  primary: 'Primario',
  secondary: 'Secundario'
}

export const en = {
  primary: 'Primary',
  secondary: 'Secondary'
}

export const ca = {
  primary: 'Primari',
  secondary: 'Secundari'
}
